import angular from 'angular';
import DashboardService from './dashboard.service';

let companyModule = angular.module('dbservice', [
])
.service('DashboardService', DashboardService);

export default companyModule;



// WEBPACK FOOTER //
// ./client/common/services/dashboard/dashboard.js